import { IconFormNames } from 'shared/assets/icons';
import { Timeslot } from 'shared/types/timeslot';

import { Habit, NewHabit } from './habit';
import { HabitSchedule } from './habit-schedule';
import { ID } from './id';
import { NewRepeatingTask, RepeatingTask } from './repeating-task';
import { TaskPriorityOptions, TaskType } from './task-base';
import { Timestamp } from './timestamp';
import { NewTodo, Todo } from './todo';

export type Task = Todo | Habit | RepeatingTask;

export type NewSubTask = { name: string; id: ID };

export type CreateTask = {
  name: string;
  description?: string | null;
  type: TaskType;
  deadlineDeadline?: Timestamp | null;
  endStrategy?: {
    deadline?: Timestamp | null;
    completionCount?: number | null;
  } | null;
  goalId: ID | null;
  sectionId: ID | null;
  lifeAreaId: ID | null;
  // tagIds will be processed into relationships
  tagIds: ID[] | null;
  reminderTime: number | null;
  parentIds: ID[] | null;
  priority: TaskPriorityOptions | null;
  schedules: HabitSchedule[] | null;
  timeslot?: Timeslot | null;
  hideOnTodo?: boolean | null;
  iconName?: IconFormNames | null;
};

export type NewTask = NewTodo | NewHabit | NewRepeatingTask;

export type MinimalNewTask = Pick<NewTask, 'name'> & Partial<NewTask>;

export type UpdateTask = Partial<Task> & Required<Pick<Task, 'id'>>;

export enum TaskCheckOptions {
  Checked = 'checked',
  Unchecked = 'unchecked',
  RepeatSingleChecked = 'repeat-single-checked',
  RepeatChecked = 'repeat-checked',
  FailedChecked = 'failed-checked',
  SkippedChecked = 'skipped-checked',
}

export type PrecomputedCompletion = {
  checked: TaskCheckOptions;
  completionPercentage?: number;
  target?: number;
};

export enum LinkOptions {
  LifeArea = 'life-area',
  Goal = 'goal',
}
